export const SUPPORT_CUSTOMERS_SPEED_DIAL = {
  ADD_NEW: 'ADD_NEW',
  ADD_SUPPORT_GROUP: 'ADD_SUPPORT_GROUP',
};

export enum CUSTOMER_STATUS_ENUM {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
